<template>
    <ion-header :translucent="true">
        <ion-toolbar>
            <ion-buttons v-if="isMobile" slot="start">
                <ion-menu-button></ion-menu-button>
            </ion-buttons>
            <ion-buttons v-else slot="end" style="gap:40px">
                <ion-button @click="router.push('/home')">Home</ion-button>
                <ion-button @click="router.push('/about')">About Us</ion-button>
                <ion-button @click="router.push('/contact')">Contact Us</ion-button>
                <ion-button @click="router.push('/projects')">Previous Work</ion-button>

            </ion-buttons>
            <ion-item lines="none">
                <ion-title>Jonathan M Net</ion-title>
                <a style="width:70px; margin-right:15%;" @click="router.push('/home')"><ion-img :src="logo" alt="Logo"></ion-img>
                </a></ion-item>
        </ion-toolbar>
    </ion-header>
</template>

<script setup lang="ts">
import { ref } from "vue";
import {
    IonHeader,
    IonToolbar,
    IonButtons,
    IonMenuButton,
    IonImg,
    IonButton,
    IonItem,
    IonTitle
} from "@ionic/vue";
const logo = new URL("../assets/logo.png", import.meta.url).href;
var isMobile = ref(false);
setInterval(() => {
    isMobile.value = window.outerWidth <= mobileBarWidth;
}, 100);
</script>

<script lang="ts">
import { mobileBarWidth } from "../helper";
import router from "@/router";

export default {
    name: 'Navbar',
}
</script>

<style scoped>
ion-header {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
}
</style>